// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner__spinner___XOfjU","bubbly":"spinner__bubbly___Xztcv","b1":"spinner__b1___YlpbP","b2":"spinner__b2___cO1ql","b3":"spinner__b3___RdYsn"};